import Vue from "vue";
import VueRouter from "vue-router";

import AppIntro from "../components/intro/AppIntro";
import Login from "../components/intro/Login";
import RegisterForm from "../components/intro/RegisterForm";
import ProjectList from "../components/projects/ProjectList";
import ProjectEdit from "../components/projects/ProjectEdit";
import ProjectCreate from "../components/projects/ProjectCreate";
import WindowList from "../components/windows/WindowList";
import WindowEdit from "../components/windows/WindowEdit";
import WindowBom from "../components/windows/WindowBom";
import UserList from "../components/users/UserList";
import UserEdit from "../components/users/UserEdit";
import SharedUserList from "../components/users/SharedUserList";
import VersionList from "../components/versions/VersionList";
import PasswordReset from "../components/intro/PasswordReset";
import PasswordInput from "../components/intro/PasswordInput";
import CilinderIntro from "../components/cilinders/CilinderIntro";
import Cilinder880 from "../components/cilinders/Cilinder880";
import Config880 from "../components/cilinders/Config880";
import DownloadsList from "../components/downloads/DownloadList";
import TermsAndConditions from "../components/intro/TermsAndConditions";
import PrivacyPolicy from "../components/intro/PrivacyPolicy";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      component: AppIntro
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/terms-and-conditions",
      component: TermsAndConditions
    },
    {
      path: "/privacy-policy",
      component: PrivacyPolicy
    },
    {
      path: "/register",
      component: RegisterForm
    },
    {
      path: "/projects/:id",
      component: ProjectList
    },
    {
      path: "/projectedit/:id",
      component: ProjectEdit
    },
    {
      path: "/projectcreate",
      component: ProjectCreate
    },
    {
      path: "/projectwindows/:id",
      component: WindowList
    },
    {
      path: "/windowedit/:id",
      component: WindowEdit
    },
    {
      path: "/bom/:id",
      component: WindowBom
    },
    {
      path: "/users",
      component: UserList
    },
    {
      path: "/edituser/:id",
      component: UserEdit
    },
    {
      path: "/versions",
      component: VersionList
    },
    {
      path: "/sharedusers",
      component: SharedUserList
    },
    {
      path: "/pwreset",
      component: PasswordReset
    },
    {
      path: "/pw/:id",
      component: PasswordInput
    },
    {
      path: "/cilinders",
      component: CilinderIntro
    },
    {
      path: "/cilinder880",
      component: Cilinder880
    },
    {
      path: "/config880",
      component: Config880
    },
    {
      path: "/downloads",
      component: DownloadsList
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js